var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgP2PLine = function SvgP2PLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.25 7.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m0 1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m-7.5-3.75a3 3 0 0 0-3 3v1.5h1.5v-1.5a1.5 1.5 0 0 1 1.5-1.5H11v-1.5zm7.5 13.5a3 3 0 0 0 3-3v-1.5h-1.5v1.5a1.5 1.5 0 0 1-1.5 1.5H14v1.5zm-6.75-6a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m1.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m5.25-1.5a1.5 1.5 0 0 0-1.5 1.5h-1.5a3 3 0 0 1 6 0h-1.5a1.5 1.5 0 0 0-1.5-1.5m-9 7.5a1.5 1.5 0 1 1 3 0h1.5a3 3 0 0 0-6 0z"
  })));
};
export default SvgP2PLine;